import { useLoaderData } from '@remix-run/react';
import { useIsDisabledInPreview } from '@modules/root/hook/use-is-disabled-in-preview';
import { useTilesAdminData } from '~/modules-rocco/admin/hooks/use-tiles-admin-data';
import { PaginatedNetwork } from '../component/network-tab/PaginatedNetwork';
import type { loader } from './loaders/network-page-loader.server';

const NetworkPage = () => {
    const data = useLoaderData<typeof loader>();
    const disableTileLink = useIsDisabledInPreview('featured_tile_links');
    const disableSaveToDesignBoard =
        useIsDisabledInPreview('save_design_board');
    const disableSort = useIsDisabledInPreview('directory_sort');
    const professionalTilesRocco = useTilesAdminData(
        data.professionalTilesRocco
    );

    return (
        <PaginatedNetwork
            {...data}
            professionalTilesRocco={professionalTilesRocco}
            disableTileLink={disableTileLink}
            disableSaveToDesignBoard={disableSaveToDesignBoard}
            disableSort={disableSort}
        />
    );
};

export default NetworkPage;
